<template>
  <div>
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <!--移动端 -->
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
            @click="navbarTarget"
          >
            <span :class="[toggle ? 'menu-remove' : 'glyphicon-menu']"></span>
          </button>
          <router-link to="/home" class="navbar-brand">
            <img src="../assets/images/logo@2x.png" />
          </router-link>
        </div>

        <!-- pc端 -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <!-- <li class="active">首页</li>
            <li class="dropdown">
              <a
                href="#"
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                产品与方案
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li><a href="#">医疗感染风险监测整体解决方案</a></li>
                <li><a href="#">新概念套箱式洁净手术室整体解决方案</a></li>
              </ul>
            </li>
            <li>成功案例</li> -->

            <template v-for="item in sidebarMenu">
              <li
                :class="{ active: item.path == location }"
                v-if="!item.children"
                :key="item.path"
              >
                <router-link :to="item.path">{{ item.title }}</router-link>
              </li>

              <li
                :class="[{ active: item.path == location }, 'dropdown']"
                v-else
                :key="item.path"
              >
                <a
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ item.title }}
                  <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                  <li v-for="child in item.children" :key="child.path">
                    <router-link :to="{ path: child.path }">
                      {{ child.title }}
                    </router-link>
                  </li>
                </ul>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="cp">
        <div class="base_layout cp_dropdown">
          <div class="cp_pic">
            <img src="@/assets/images/dropdown.png" alt="" />
          </div>
          <div class="link">
            <dl>
              <dt>产品与方案</dt>
              <dd><router-link to="/medical">医疗感染风险监测整体解决方案</router-link></dd>
              <dd><router-link to="/concept">新概念套箱式洁净手术室整体解决方案</router-link></dd>
            </dl>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  watch: {
    $route() {
      this.location = this.$route.name;
      window.scrollTo(0, 0);
      $(".navbar-collapse").collapse("hide");
      this.toggle = false;
    },
  },
  data() {
    return {
      location: this.$route.name,
      toggle: false,
    };
  },

  computed: {
    sidebarMenu() {
      return this.$router.options.routes.filter((x) => !x.hidden);
    },
  },
  mounted() {
    this.clickNavbar();
    $(".dropdown").mouseover(function () {
      $(".cp").css({ display: "block" });
    });
    $(".cp").mouseover(function () {
      $(".cp").css({ display: "block" });
    });

    $(".dropdown").mouseout(function () {
      $(".cp").css({ display: "none" });
    });
    $(".cp").mouseout(function () {
      $(".cp").css({ display: "none" });
    });
  },
  methods: {
    navbarTarget() {
      this.toggle = !this.toggle;
    },
    clickNavbar() {
      const that = this;
      $(function () {
        const navMain = $(".navbar-collapse");
        navMain.on("click", "a:not([data-toggle])", null, function () {
          navMain.collapse("hide");
          that.toggle = false;
        });
      });
    },
  },
};
</script>
